export default __webpack_public_path__ + "static/media/logofull.e5cc79fa.png";